import React from 'react';
import { observer } from 'mobx-react';
import { ButtonClickEvent } from 'ui/base/types';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import { PolicyEntry, getPolicyEntryIcon, getPolicyEntryLabel } from './policy_entry_logic';
import baseStyles from './policy_entry.module.css';

type CategoryInputStyles = {
  plainContainer: string;
  clickableContainer: string;
  iconContainer: string;
  detailContainer: string;
  bareButton: string;
  removeIcon: string;

  // Policy-specific icons
  entireInternetIcon: string;
  adultSitesIcon: string;
  entertainmentSitesIcon: string;
  gamingSitesIcon: string;
  socialMediaIcon: string;
};

const themedStyles: ThemedStyles<CategoryInputStyles> = {
  [Theme.DAYLIGHT]: {
    plainContainer: baseStyles.plainContainer,
    clickableContainer: baseStyles.clickableContainer,
    iconContainer: baseStyles.iconContainer,
    detailContainer: baseStyles.detailContainer,
    bareButton: baseStyles.bareButton,
    removeIcon: baseStyles.midnightRemoveIcon,

    // Policy-specific icons
    entireInternetIcon: baseStyles.daylightEntireInternetIcon,
    adultSitesIcon: baseStyles.daylightAdultSitesIcon,
    entertainmentSitesIcon: baseStyles.daylightEntertainmentSitesIcon,
    gamingSitesIcon: baseStyles.daylightGamingSitesIcon,
    socialMediaIcon: baseStyles.daylightSocialMediaIcon,
  },
  [Theme.MIDNIGHT]: {
    plainContainer: baseStyles.plainContainer,
    clickableContainer: baseStyles.clickableContainer,
    iconContainer: baseStyles.iconContainer,
    detailContainer: baseStyles.detailContainer,
    bareButton: baseStyles.bareButton,
    removeIcon: baseStyles.midnightRemoveIcon,

    // Policy-specific icons
    entireInternetIcon: baseStyles.midnightEntireInternetIcon,
    adultSitesIcon: baseStyles.midnightAdultSitesIcon,
    entertainmentSitesIcon: baseStyles.midnightEntertainmentSitesIcon,
    gamingSitesIcon: baseStyles.midnightGamingSitesIcon,
    socialMediaIcon: baseStyles.midnightSocialMediaIcon,
  },
};

type RemovablePolicyEntryProps = {
  entry: PolicyEntry;
  onRemoveClick: (event: ButtonClickEvent) => void;
};

export const RemovablePolicyEntry = observer(({ entry, onRemoveClick }: RemovablePolicyEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.plainContainer}>
      <div className={styles.iconContainer}>
        <div className={getPolicyEntryIcon(styles, entry)}/>
      </div>
      <div className={styles.detailContainer}>
        <div>
          {getPolicyEntryLabel(entry)}
        </div>
        <button type='button' className={styles.bareButton} onClick={onRemoveClick}>
          <div className={styles.removeIcon}/>
        </button>
      </div>
    </div>
  );
});

export type SearchPolicyEntryProps = {
  data: PolicyEntry;
  onSelect: () => void;
};

export const SearchPolicyEntry = observer(({ data: entry, onSelect }: SearchPolicyEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.clickableContainer} onClick={onSelect}>
      <div className={styles.iconContainer}>
        <div className={getPolicyEntryIcon(styles, entry)}/>
      </div>
      <div className={styles.detailContainer}>
        {getPolicyEntryLabel(entry)}
      </div>
    </div>
  );
});


export type PlainPolicyEntryProps = {
  entry: PolicyEntry;
};
export const PlainPolicyEntry = observer(({ entry }: PlainPolicyEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.plainContainer}>
      <div className={styles.iconContainer}>
        <div className={getPolicyEntryIcon(styles, entry)}/>
      </div>
      <div className={styles.detailContainer}>
        {getPolicyEntryLabel(entry)}
      </div>
    </div>
  );
});
